import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    isLogedIn: false,
    token: '',
    userID: '',
    email: '',
    name: '',
  },
  reducers: {
    logIn(state, action) {
      const logPayload = action.payload;
      return {
        isLogedIn: true,
        token: logPayload.token,
        userID: logPayload.userID,
        email: logPayload.email,
        name: logPayload.name,
      };
    },
    logout() {
      return {
        isLogedIn: false,
        token: '',
        userID: '',
        email: '',
        name: '',
      };
    },
  },
});

export const authAction = authSlice.actions;

export default authSlice;
